import type { ReactNode, Ref } from 'react';

import { chatStyles } from '@/shared/ui/chat/styles';

export function ChatSurface({ children }: { children: ReactNode }) {
	return (
		<div className="flex h-full w-full flex-col bg-gray-5 text-base text-black">
			{children}
		</div>
	);
}

export function ChatScrollArea({
	children,
	scrollRef,
}: {
	children: ReactNode;
	scrollRef: Ref<HTMLDivElement>;
}) {
	return (
		<div ref={scrollRef} className="flex-1 overflow-y-auto">
			{children}
		</div>
	);
}

export function ChatTranscript({ children }: { children: ReactNode }) {
	return <div className="pb-4 pt-6">{children}</div>;
}

export function ChatFooter({ children }: { children: ReactNode }) {
	return (
		<div className={chatStyles.footer}>
			<div className="mx-auto max-w-[720px]">{children}</div>
		</div>
	);
}
